// extracted by mini-css-extract-plugin
export default {"layout-wrapper":"LayoutWrapper_layout-wrapper__WjigO","layout-wrapper__navigation":"LayoutWrapper_layout-wrapper__navigation__j7sLG"};